import { render, staticRenderFns } from "./forgetPasswordCheck.vue?vue&type=template&id=1c053e92&scoped=true&"
import script from "./forgetPasswordCheck.vue?vue&type=script&lang=js&"
export * from "./forgetPasswordCheck.vue?vue&type=script&lang=js&"
import style0 from "./forgetPasswordCheck.vue?vue&type=style&index=0&id=1c053e92&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c053e92",
  null
  
)

export default component.exports